import Vue from 'vue'
import Vuex from 'vuex'
import Storage from './helpers/storage'
import Api from './api'
import ENUM from './assets/ENUM'

import UCUser from './app-core/use-cases/user'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        user: {},
        stats: {},
        settings: {},
        partners: {},
        email: '',
        scroll: false,
        lang: '',
        page: '',
        maintenance: false,
        internet: true,
        newsletters: [],
        newslettersBus: [],
        countSelectedNewsletters: 0,
        unselectedAllNewsletters: false,
        newslettersSort: ENUM.NEWSLETTERS.SORT.NOT_SET,
        isSelectedMailboxesInit: false,
        selectedMailboxes: [],
        mailboxes: [],
        isCardTuto: false,
        actualPartner: {},
        newslettersSearchingMode: ENUM.NEWSLETTERS.SEARCHING_MODE.UNACTIVE,
        searchValue: '',
        newslettersPage: '',
        isCardDraging: false,
        cardDragDirection: '',
        emailToDeleteRedirect: '',
        isNavigationOpen: false,
        fetchStatus: '',
        fetchEndNotif: false,
        isFirstRefreshDone: false,
        isRefreshActive: false,
        newslettersTemp: [],
        actionsBatchTempUnsubscribe: [],
        actionsBatchTempKeep: [],
        actionsBatchTempDelete: []
    },
    mutations: {

        UPDATE_USER: (state, user) => {
            state.user = user
        },

        UPDATE_STATS: (state, stats) => {

            state.stats = stats
        },

        UPDATE_SETTINGS: (state, settings) => {
            state.settings = settings
        },

        UPDATE_PARTNERS: (state, partners) => {
            state.partners = partners
        },

        EMAIL: (state, email) => {
            state.email = email
        },

        SCROLL: (state, bool) => {
            state.scroll = bool
        },

        LANG: (state, lang) => {
            state.lang = lang
        },

        PAGE: (state, page) => {
            state.page = page
        },

        MAINTENANCE: (state, maintenance) => {
            state.maintenance = maintenance
        },

        INTERNET: (state, internet) => {
            state.internet = internet
        },

        NEWSLETTERS: (state, newsletters) => {
            state.newsletters = newsletters
        },

        NEWSLETTERS_BUS: (state, newslettersBus) => {
            state.newslettersBus = newslettersBus
        },

        FETCH_STATUS: (state, status) => {
            state.fetchStatus = status
        },

        COUNT_SELECTED_NEWSLETTERS: (state, countSelectedNewsletters) => {
            state.countSelectedNewsletters = countSelectedNewsletters
        },

        UNSELECT_ALL_NEWSLETTERS: (state, unselectedAllNewsletters) => {
            state.unselectedAllNewsletters = unselectedAllNewsletters
        },

        NEWSLETTERS_SORT: (state, newslettersSort) => {
            state.newslettersSort = newslettersSort
        },

        IS_CONNECTED: (state, isConnected) => {
            state.isConnected = isConnected
        },

        SELECTED_MAILBOXES: (state, selectedMailboxes) => {
            state.selectedMailboxes = selectedMailboxes
        },

        IS_SELECTED_MAILBOXES_INIT: (state, bool) => {
            state.isSelectedMailboxesInit = bool
        },

        MAILBOXES: (state, mailboxes) => {
            state.mailboxes = mailboxes
        },

        IS_CARD_TUTO: (state, isCardTuto) => {
            state.isCardTuto = isCardTuto
        },

        ACTUAL_PARTNER: (state, actualPartner) => {
            state.actualPartner = actualPartner
        },

        NEWSLETTERS_SEARCHING_MODE: (state, mode) => {
            state.newslettersSearchingMode = mode
        },

        UPDATE_SEARCH_VALUE: (state, value) => {
            state.searchValue = value
        },

        UPDATE_NEWSLETTERS_PAGE: (state, newPage) => {
            state.newslettersPage = newPage
        },

        UPDATE_CARD_DRAGING: (state, bool) => {
            state.isCardDraging = bool
        },

        UPDATE_CARD_DRAG_DIRECTION: (state, direction) => {
            state.cardDragDirection = direction
        },

        EMAIL_TO_DELETE_REDIRECT: (state, emailToDeleteRedirect) => {
            state.emailToDeleteRedirect = emailToDeleteRedirect
        },

        UPDATE_IS_NAVIGATION_OPEN: (state, bool) => {
            state.isNavigationOpen = bool
        },

        UPDATE_FETCH_END_NOTIF: (state, bool) => {
            state.fetchEndNotif = bool
        },

        IS_FIRST_REFRESH_DONE: (state, bool) => {
            state.isFirstRefreshDone = bool
        },

        IS_REFRESH_ACTIVE: (state, bool) => {
            state.isRefreshActive = bool
        },

        NEWSLETTERS_TEMP: (state, newslettersTemp) => {
            state.newslettersTemp = newslettersTemp
        },

        ACTIONS_BATCH_TEMP_UNSUBSCRIBE: (state, actionsBatchTempUnsubscribe) => {
            state.actionsBatchTempUnsubscribe = actionsBatchTempUnsubscribe
        },

        ACTIONS_BATCH_TEMP_KEEP: (state, actionsBatchTempKeep) => {
            state.actionsBatchTempKeep = actionsBatchTempKeep
        },

        ACTIONS_BATCH_TEMP_DELETE: (state, actionsBatchTempDelete) => {
            state.actionsBatchTempDelete = actionsBatchTempDelete
        }

    },
    getters: {
        user: state => state.user,
        stats: state => state.stats,
        settings: state => state.settings,
        partners: state => state.partners,
        scroll: state => state.scroll,
        lang: state => state.lang,
        page: state => state.page,
        maintenance: state => state.maintenance,
        internet: state => state.internet,
        newsletters: state => state.newsletters,
        newslettersBus: state => state.newslettersBus,
        countSelectedNewsletters: state => state.countSelectedNewsletters,
        unselectedAllNewsletters: state => state.unselectedAllNewsletters,
        newslettersSort: state => state.newslettersSort,
        isConnected: state => state.user && state.user.hash,
        isFirstRefreshDone: state => state.isFirstRefreshDone,
        selectedMailboxes: state => state.selectedMailboxes,
        mailboxes: state => state.mailboxes,
        isCardTuto: state => state.isCardTuto,
        actualPartner: state => state.actualPartner,
        anonymousUser: state => state.user && state.user.hash && (!state.user.firstname || (!state.user.birthYear || state.user.birthYear < 1)),
        newslettersSearchingMode: state => state.newslettersSearchingMode,
        searchValue: state => state.searchValue,
        newslettersPage: state => state.newslettersPage,
        isCardDraging: state => state.isCardDraging,
        cardDragDirection: state => state.cardDragDirection,
        emailToDeleteRedirect: state => state.emailToDeleteRedirect,
        isNavigationOpen: state => state.isNavigationOpen,
        fetchStatus: state => state.fetchStatus,
        fetchEndNotif: state => state.fetchEndNotif,
        newslettersTemp: state => state.newslettersTemp,
        isRefreshActive: state => state.isRefreshActive,
        newslettersWaiting: state => state.newslettersBus.length > 0,
        enoughNewsletters: state => state.newsletters.length + state.newslettersBus.length > 9,
        actionsBatchTempUnsubscribe: state => state.actionsBatchTempUnsubscribe,
        actionsBatchTempKeep: state => state.actionsBatchTempKeep,
        actionsBatchTempDelete: state => state.actionsBatchTempDelete
    },
    actions: {

        setUser: (store, user = {}) => store.commit('UPDATE_USER', user),

        disconnect(store) {

            Storage.removeItem('token')
            store.commit('UPDATE_USER', {})
        },

        getUserAsync: function (store) {

            if (store.state.user && store.state.user.accounts) {
                return Promise.resolve(store.state.user)
            } else {
                return UCUser.getUserAsync()
                    .then(user => {
                        return store.dispatch('updateUser', user)
                    })
            }
        },

        getUserSync: async function (store) {
            return await UCUser.getUserSync()
                .then(user => {
                    return store.dispatch('updateUser', user)
                })
        },

        updateUser(store, user) {
            store.dispatch('setUser', user)
            return user
        },

        getStatsAsync: async function ({commit}) {
            //refresh always stats, but some modules need stats
            return Api.user.getStats()
                .then(stats => {
                    commit('UPDATE_STATS', stats)
                    return stats
                })
        },

        getSettingsAsync: function ({commit}) {
            return Api.user.getSettings()
                .then(settings => {
                    commit('UPDATE_SETTINGS', settings)
                    return settings
                })
        },

        getPartnersAsync: function ({commit, state}) {
            if (Object.keys(state.partners).length) {
                return state.partners
            }
            return Api.partners.getAll()
                .then(partners => {
                    commit('UPDATE_PARTNERS', partners)
                    return partners
                })
        },

        setLang: (store, lang) => store.commit('LANG', lang),

        setPage: (store, page) => store.commit('PAGE', page),

        setMaintenance: (store, maintenance) => store.commit('MAINTENANCE', maintenance),

        setInternetStatus: (store, bool) => store.commit('INTERNET', bool),

        updateNewsletters: async (store, force = false) => {
            // fill newsletters with newslettersBus
            if(force || store.getters.newslettersBus.length > store.getters.newsletters.length) {
                const newslettersBus = store.getters.newslettersBus
                await store.dispatch('fillNewsletters', newslettersBus)
                await store.dispatch('fillNewslettersBus', [])
                await store.dispatch('updateFetchEndNotif', false)
            }
        },

        // newsletters is the var for client manipulations
        fillNewsletters: (store, newsletters) => store.commit('NEWSLETTERS', newsletters),

        // newslettersBus is a queu of new newsletters waiting user action to be added in newsletters
        fillNewslettersBus: (store, newslettersBus) => store.commit('NEWSLETTERS_BUS', newslettersBus),

        // newslettersTemp is a footprint of the last get subscription response with subscriptions (bafore sort) to check if news subscriptions was added
        updateNewslettersTemp: (store, array) => store.commit('NEWSLETTERS_TEMP', array),

        updateFetchStatus: (store, status) => store.commit('FETCH_STATUS', status),

        firstRefreshNewsletters: async (store) => {
            // run refreshNewsletters if not already done
            if (!store.getters.isFirstRefreshDone) {
                await store.dispatch('refreshNewsletters')
            }
        },

        updateIsFirstRefreshDone: (store, bool) => store.commit('IS_FIRST_REFRESH_DONE', bool),

        refreshNewsletters: async (store) => {
            // call API for GET newsletters and init variables
            if (Storage.getItem('token') && !store.getters.isRefreshActive) {

                await store.dispatch('updateIsRefreshActive', true)

                const fetchResult = await UCUser.refreshSubscriptions(async function (fetchMeantime) {
                    // This code is call only if retry in request
                    await store.dispatch('updateMailboxes', fetchMeantime.mailboxes)
                    await store.dispatch('addNewsletters', fetchMeantime)
                    //always fetch status on the last
                    await store.dispatch('updateFetchStatus', fetchMeantime.status)
                })
                if (!fetchResult) {
                    return
                }
                await store.dispatch('updateMailboxes', fetchResult.mailboxes)

                await store.dispatch('addNewsletters', fetchResult)
                // if refresh was long, need to show notification
                if ((store.getters.fetchStatus === ENUM.FETCH_STATUS.PENDING || store.getters.fetchStatus === ENUM.FETCH_STATUS.PARTIAL) && fetchResult.status === ENUM.FETCH_STATUS.DONE) {
                    await store.dispatch('updateFetchEndNotif', true)
                }
                //always fetch status on the last of refresh actions
                await store.dispatch('updateFetchStatus', fetchResult.status)

                await store.dispatch('updateIsRefreshActive', false)
            }
        },

        async addNewsletters(store, newsletters = {}) {
            const allSubscriptions = [...newsletters.subscriptions||[], ...newsletters.incrementalSubscriptions || []]
            // Function for distribute newsletters in "newsletters" var or "newslettersBus"
            if (allSubscriptions.length) {
                if (JSON.stringify(allSubscriptions) !== JSON.stringify(store.getters.newslettersTemp)) {
                    store.dispatch('updateNewslettersTemp', allSubscriptions)
                    if (!store.getters.isFirstRefreshDone) {
                        await store.dispatch('fillNewsletters', await UCUser.sortSubscriptions(allSubscriptions, newsletters.extras))
                    } else {
                        await store.dispatch('fillNewslettersBus', await UCUser.sortSubscriptions(allSubscriptions, newsletters.extras))
                    }
                }
            }
            await store.dispatch('updateIsFirstRefreshDone', true)
        },

        updateIsRefreshActive: (store, bool) => store.commit('IS_REFRESH_ACTIVE', bool),

        updateCountSelectedNewsletters: (store, countSelectedNewsletters) => store.commit('COUNT_SELECTED_NEWSLETTERS', countSelectedNewsletters),

        unselectAllNewsletters: (store) => {
            store.commit('COUNT_SELECTED_NEWSLETTERS', 0)
            store.commit('UNSELECT_ALL_NEWSLETTERS', !store.getters.unselectedAllNewsletters)
        },

        updateNewslettersSort: (store, newslettersSort) => {
            store.commit('NEWSLETTERS_SORT', newslettersSort)
            Storage.setItem('newslettersSort', newslettersSort)
        },

        updateSelectedMailboxes: (store, selectedMailboxes) => store.commit('SELECTED_MAILBOXES', selectedMailboxes),

        updateIsSelectedMailboxes: (store, bool) => store.commit('IS_SELECTED_MAILBOXES_INIT', bool),

        updateMailboxes: (store, mailboxes) => {
            store.commit('MAILBOXES', mailboxes)
            if (!store.state.isSelectedMailboxesInit) {
                store.dispatch('updateSelectedMailboxes', mailboxes.map(mailbox => mailbox.email))
                store.dispatch('updateIsSelectedMailboxes', true)
            }
        },

        updateIsCardTuto: (store, isCardTuto) => store.commit('IS_CARD_TUTO', isCardTuto),

        removeMailboxes: (store, removedEmail) => {
            const currentMailboxes = JSON.parse(JSON.stringify(store.state.mailboxes))
            const newMailboxes = currentMailboxes.filter(mailbox => mailbox.email !== removedEmail)
            store.dispatch('updateMailboxes', newMailboxes)
        },

        initNewsletterSort: (store) => {
            const newslettersSort = Storage.getItem('newslettersSort')
            if (newslettersSort && Object.values(ENUM.NEWSLETTERS.SORT).includes(newslettersSort)) {
                store.dispatch('updateNewslettersSort', newslettersSort)
            } else {
                store.dispatch('updateNewslettersSort', ENUM.NEWSLETTERS.SORT.NOT_SET)
            }
        },

        updateActualPartner: (store, actualPartner) => store.commit('ACTUAL_PARTNER', actualPartner),

        updateNewslettersSearchingMode: (store, mode) => store.commit('NEWSLETTERS_SEARCHING_MODE', mode),

        updateSearchValue: (store, value) => store.commit('UPDATE_SEARCH_VALUE', value),

        updateNewslettersPage: (store, newPage) => store.commit('UPDATE_NEWSLETTERS_PAGE', newPage),

        updateCardDraging: (store, bool) => store.commit('UPDATE_CARD_DRAGING', bool),

        updateCardDragDirection: (store, direction) => store.commit('UPDATE_CARD_DRAG_DIRECTION', direction),

        updateEmailToDeleteRedirect(store, emailToDeleteRedirect = '') {
            Storage.setItem('emailToDeleteRedirect', emailToDeleteRedirect)
            store.commit('EMAIL_TO_DELETE_REDIRECT', emailToDeleteRedirect)
        },

        updateIsNavigationOpen: (store, bool) => store.commit('UPDATE_IS_NAVIGATION_OPEN', bool),

        updateFetchEndNotif: (store, bool) => store.commit('UPDATE_FETCH_END_NOTIF', bool),

        updateActionsBatchTempUnsubscribe: (store, actionsBatchTempUnsubscribe) => store.commit('ACTIONS_BATCH_TEMP_UNSUBSCRIBE', actionsBatchTempUnsubscribe),

        updateActionsBatchTempKeep: (store, actionsBatchTempKeep) => store.commit('ACTIONS_BATCH_TEMP_KEEP', actionsBatchTempKeep),

        updateActionsBatchTempDelete: (store, actionsBatchTempDelete) => store.commit('ACTIONS_BATCH_TEMP_DELETE', actionsBatchTempDelete)

    },
    strict: true
})
